var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWashroom = function SvgWashroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 15.2 21.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M.6 13.6h14m-9.5-7V5.1a.5.5 0 0 1 .5-.5h2m0 0h2a.5.5 0 0 1 .5.5v1.5m-2.5-2v-4m0 0H4.718a.5.5 0 0 0-.224.053L2.6 1.6m5-1h3m-5 6h4a5 5 0 0 1 5 5v6a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3v-6a5 5 0 0 1 5-5"
  })));
};
export default SvgWashroom;